import { jsxs as r, jsx as l } from "react/jsx-runtime";
const t = (c) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m48.108 56.095-.803-2.997.01-.003h-6.357v-2.51l-3.214-9.216-.405-1.153-1.211.16c-.08.011-8.057.999-14.112-4.252L19.88 34.27l-.336 2.808c-.54 4.518-2.627 5.7-5.042 7.068l-.233.132c-3.272 1.86-3.342 4.349-3.339 4.627l-.025 1.462 1.454.021c.092.008.816.09 1.495.587.64.468 1.067 1.178 1.277 2.118l2.898-.776c-.49-2.05-1.606-3.228-2.583-3.89a6.118 6.118 0 0 0-.973-.535c.27-.312.674-.663 1.278-1.005l.23-.13c2.2-1.247 4.857-2.752 6.052-6.858 5.175 3.442 10.81 3.652 13.259 3.548l2.666 7.645v5.002h10.15Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M18.29 56.074H6.668V45.081c0-1.393.9-2.459 1.771-3.49 1.133-1.34 2.304-2.725 2.304-5.132 0-5.841 4.752-10.594 10.594-10.594h9.625c2.702 0 4.916-.523 6.404-1.513 1.675-1.115 2.49-2.834 2.49-5.254v-.242c-.006-2.42-.019-8.088 4.125-12.037l2.385-2.273.148 3.292c.085 1.837.486 3.854.872 4.46 2.703.307 4.83 1.473 6.073 3.32l5.102 1.807.06.992c.128 2.132-.726 6.42-4.875 7.397-1.334.314-2.121.67-2.405 1.092-.267.394-.307 1.137-.362 2.165-.01.202-.022.413-.036.632-.222 3.556-1.293 5.373-2.534 7.478-.575.977-1.17 1.987-1.788 3.33-1.258 2.74-1.247 5.78-1.13 7.337 1.318.304 2.415.925 3.271 1.853 1.072 1.161 1.705 2.753 1.883 4.73l.147 1.634H37.966v-5.002L35.3 43.418c-2.45.104-8.084-.106-13.259-3.548-1.195 4.107-3.852 5.611-6.052 6.858l-.23.13c-.603.343-1.007.693-1.278 1.005.314.137.644.313.974.536 1.293.875 2.835 2.657 2.835 6.175v1.5Zm-8.622-3h5.473c-.209-.945-.636-1.658-1.278-2.127a3.229 3.229 0 0 0-1.495-.588l-1.455-.02.025-1.463c-.003-.278.067-2.768 3.34-4.627l.232-.132c2.416-1.368 4.502-2.55 5.042-7.068l.336-2.808 2.136 1.853c6.09 5.281 14.03 4.264 14.109 4.253l1.216-.166 3.617 10.374v2.51h6.363c-.521-1.502-1.6-2.28-3.315-2.414l-1.154-.09-.205-1.14c-.04-.219-.94-5.42 1.24-10.163.681-1.482 1.344-2.607 1.93-3.6 1.172-1.99 1.947-3.303 2.124-6.142.013-.21.024-.412.034-.606.075-1.395.14-2.6.871-3.683.757-1.12 2.014-1.818 4.205-2.334 1.132-.266 1.878-1.01 2.28-2.272.121-.38.192-.752.233-1.072l-4.153-1.472-.276-.5c-.97-1.764-3.107-2.21-4.295-2.32-1.77-.162-2.49-2.154-2.8-3.436-1.202 2.604-1.196 5.436-1.193 7.028v.249c0 6.207-4.334 9.767-11.893 9.767h-9.625c-4.188 0-7.594 3.407-7.594 7.594 0 3.505-1.741 5.565-3.012 7.069-.474.56-1.063 1.258-1.063 1.553v7.993Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m38.217 25.542-1.473 1.354L46.401 37.4l1.472-1.354-9.656-10.504ZM31.863 27.43l-1.98.29 2.034 13.892 1.979-.29-2.033-13.892Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m35.983 43.425-.458-2.964c4.563-.706 7.059-1.81 8.349-2.611.995-.62 1.364-1.118 1.365-1.122l2.699 1.312c-.311.639-2.347 3.9-11.955 5.385ZM7.842 39.064l-1.94-.487c.033-.13.822-3.214 3.093-6.324 3.051-4.179 7.319-6.388 12.342-6.388v2c-4.399 0-7.995 1.856-10.688 5.515-2.06 2.798-2.8 5.655-2.807 5.684Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "#fff",
          d: "m53.517 51.42-6.189 1.659 1.658 6.188 6.189-1.658-1.658-6.188Z"
        }
      )
    ]
  }
);
export {
  t as SecurityDog
};
